import React, { PureComponent } from 'react';
import { HtmlContent } from '../../../components/layout/HtmlContent';
import { List, ListItem } from '../../../components/List';
import {
  OverlayClose,
  OverlayContainer,
  OverlayContentWrapper,
  OverlayHeader
} from '../../../components/OverlayTip';
import { SvgIcon } from '../../../components/SvgIcon';
import {
  withBookmarks,
  WithBookmarksProps
} from '../../../provider/BookmarkProvider/withBookmarks';
import {
  withTypo3Translation,
  WithTypo3TranslationProps
} from '../../../provider/Typo3Provider/withTypo3Translation';
import {
  dismissBookmarkOverlay,
  dismissedBookmarkOverlay
} from '../../../utils/BookmarkOverlayCookie';

interface BookmarkOverlayTipProps {}

interface BookmarkOverlayTipState {
  show: boolean;
  numBookmarks: number;
}

/**
 * this component shows a tip for bookmarking.
 * everytime the user adds a bookmark, this component
 * determines wether ist should display itself or not.
 * if it is dismissed by the user, this component saves
 * a cookie.
 * this cookie is stored as long as it is defined via the
 * `BOOKMARK_OVERLAY_DISMISS_EXPIRE` environment constant.
 * when the cookie expires, this component will show itself
 * again as soon as the user adds a new bookmark.
 */
class BookmarkOverlayTip extends PureComponent<
  BookmarkOverlayTipProps & WithTypo3TranslationProps & WithBookmarksProps,
  BookmarkOverlayTipState
> {
  public static getDerivedStateFromProps(
    {
      bookmarkApi: { bookmarks }
    }: BookmarkOverlayTipProps & WithBookmarksProps,
    { numBookmarks }: BookmarkOverlayTipState
  ): Partial<BookmarkOverlayTipState> | null {
    if (bookmarks.length > numBookmarks) {
      return {
        show: !dismissedBookmarkOverlay() && numBookmarks >= 0,
        numBookmarks: bookmarks.length
      };
    }
    return { numBookmarks: bookmarks.length };
  }

  public state = {
    numBookmarks: -1,
    show: false,
    status: null
  };

  public dismiss = () => {
    dismissBookmarkOverlay();
    this.setState({ show: false });
  };

  public render() {
    const { typo3Translate } = this.props;
    const { show } = this.state;
    return (
      <OverlayContainer show={show}>
        <OverlayClose onClick={this.dismiss}>
          <SvgIcon icon="close" />
        </OverlayClose>

        <OverlayContentWrapper>
          <OverlayHeader>
            <HtmlContent
              htmlString={typo3Translate('overlayTip.bookmark.headline')}
            />
          </OverlayHeader>
          <List>
            {typo3Translate('overlayTip.bookmark.points')
              .split(';')
              .map((item, index) => (
                <ListItem key={index}>
                  <SvgIcon icon={'check'} />
                  <span>
                    <HtmlContent htmlString={item} />
                  </span>
                </ListItem>
              ))}
          </List>
        </OverlayContentWrapper>
      </OverlayContainer>
    );
  }
}

export default withBookmarks(withTypo3Translation(BookmarkOverlayTip));
